var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.signOut}},[_vm._v("Sign Out")])}
var staticRenderFns = []

export { render, staticRenderFns }